import { render } from "./RankingChallengesView.vue?vue&type=template&id=4acc8e90"
import script from "./RankingChallengesView.vue?vue&type=script&lang=js"
export * from "./RankingChallengesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__